// src/components/sdk/utils/StorageUtil.tsx

import { UserRole } from "../../../services/Macro";

class StorageUtil {
    getUserRoleFromStorage(): UserRole {
        try {
            const userStr = localStorage.getItem('sdk_user');
            if (userStr) {
                const user = JSON.parse(userStr);
                const role = user.role ?? user.userRole ?? user.roleId;

                if (role === 1 || role === '1' || role === 'admin' || role === 'ADMIN') {
                    return UserRole.ADMIN;
                }
                if (role === 2 || role === '2' || role === 'normal' || role === 'NORMAL') {
                    return UserRole.NORMAL;
                }
                if (role === 3 || role === '3' || role === 'guest' || role === 'GUEST') {
                    return UserRole.GUEST;
                }
            }
        } catch (e) {
            console.error('获取用户角色失败:', e);
        }
        return UserRole.NORMAL;
    };

    isAdmin(): boolean {
        const role = this.getUserRoleFromStorage();
        return role === UserRole.ADMIN;
    };

    isGuest(): boolean {
        const role = this.getUserRoleFromStorage();
        return role === UserRole.GUEST;
    };
}

export const storageUtil = new StorageUtil;